import { useProductPartsCount } from 'hooks/orderForms/useProductPartsCount';
import { formatCurrency } from 'support/helpers/currency/currency';
import { OrderFormProductDTO } from 'support/types';
import { ProductPartsInfo } from 'components/OrderForms/ProductPartsInfo/ProductPartsInfo';

import { OrderProductQuantityAndUnitMeasure } from './components/OrderProductQuantityAndUnitOfMeasure/OrderProductQuantityAndUnitMeasure';

type OrderedProductDetailProps = {
  quantity: number;
  currency?: string;
  productData: OrderFormProductDTO;
};

export function OrderedProductDetail({ quantity, productData, currency }: OrderedProductDetailProps) {
  const partsCount = useProductPartsCount(productData);
  const pricePerUnit = productData.discounted_unit_price;
  return (
    <>
      <OrderProductQuantityAndUnitMeasure quantity={quantity} product={productData} />
      <div className="text-xs leading-4 font-normal">
        <dt className="text-gray-900">{productData.name}</dt>
        {partsCount !== null && (
          <dd className="text-gray-500">
            <ProductPartsInfo product={productData} partsCount={partsCount} />
          </dd>
        )}
      </div>
      {typeof pricePerUnit === 'number' ? (
        <dd className="text-right text-xs leading-4 font-medium text-gray-900">
          {formatCurrency(quantity * pricePerUnit, currency)}
        </dd>
      ) : null}
    </>
  );
}
